import { createApp } from 'vue'
import RegisterIsland from './RegisterIsland.vue'
import { REGISTER_ISLAND_ID } from './register.ts'

const MOUNT_ID = REGISTER_ISLAND_ID

export function mountRegisterIsland() {
  const el = document.getElementById(MOUNT_ID)
  if (!el) {
    return
  }
  if (el.dataset.islandMounted === 'true') {
    return
  }
  el.dataset.islandMounted = 'true'
  el.innerHTML = ''
  createApp(RegisterIsland).mount(el)
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountRegisterIsland)
  } else {
    mountRegisterIsland()
  }
}
